import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import 'modern-normalize';

import '../styles/index.css';

import { MainProviders } from '@app/providers/index.js';

import { App } from './App.jsx';

const root = createRoot(document.getElementById('root'));

root.render(
	<StrictMode>
		<MainProviders>
			<App />
		</MainProviders>
	</StrictMode>,
);
